export function setActiveCompanyId(companyId) {
    return {
        type: 'SET_ACTIVE_COMPANY_ID',
        payload: {
            companyId: companyId
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/app.js